import LazyLoad from "vanilla-lazyload";
//import Masonry from "masonry-layout";
const Flickity = require("flickity-fade");
import socialIcons from "social-icons";
import arRows from "ar-rows";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import zenscroll from "zenscroll";

/* SETUP VARS */
let bw = document.body.scrollWidth;
let dpr = window.devicePixelRatio;
const body = document.querySelector("body");
const menuBtn = document.querySelector(".menuBtn");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const nav = document.querySelector("nav");
const navItems = nav.querySelectorAll("li.primary");
const overlay = document.getElementById("overlay");
const overlayInner = overlay.querySelector(".inner");
const overlayCloser = overlay.querySelector(".closer");

window.addEventListener("load", function () {
  body.classList.remove("preload");
});

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  // homepage loading
  if (body.classList.contains("loading")) {
    menuBtn.style.opacity = 0;
    setTimeout(function () {
      body.classList.remove("loading");
    }, 1000);
    setTimeout(function () {
      menuBtn.style.opacity = 1;
      menuBtn.style.animation = "bounce-in 2s";
    }, 1500);
  }

  // global animation effects
  ScrollTrigger.batch(".fadeUp", {
    onEnter: (elements, triggers) => {
      gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
    },
  });

  ScrollTrigger.batch(".fadeOn", {
    onEnter: (elements, triggers) => {
      gsap.to(elements, { opacity: 1, stagger: 0.1 });
    },
  });

  setTimeout(function () {
    ScrollTrigger.batch(".fadeUpDelay", {
      onEnter: (elements, triggers) => {
        gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
      },
    });
  }, 300);

  // check for any inline sizeload videos
  let sizeLoadVideoEls = document.querySelectorAll("video.sizeload");
  sizeLoadVideoEls.forEach((sizeLoadVideoEl) => {
    sizeloadVideo(sizeLoadVideoEl, "yes");
  });

  // check for any social icons
  if (typeof socialIcons != "undefined") {
    socialIcons(socialEl);
  }

  // init AR Rows type layout
  if (typeof arRows != "undefined") {
    arRows(rowsEl);
  }

  // any cols from text editor need to be wrapped in cols class
  let textCols = document.querySelectorAll(".text-block");
  for (var i = 0; i < textCols.length; i++) {
    wrapCols(textCols[i]);
  }

  //initialize lazyload - sitewide for image
  const lazyLoad = new LazyLoad({
    elements_selector: ".loadmeview",
    callback_enter: loadImage,
  });

  //initialize lazyload - autoplay videos
  const lazyLoadAutoVideo = new LazyLoad({
    elements_selector: ".autovideo",
    threshold: 30,
    callback_enter: playAutoVideo,
    callback_exit: pauseAutoVideo,
  });

  // initialize masonry

  let masonGrids = document.querySelectorAll(".masongrid");
  masonGrids.forEach((masonGrid) => {
    //injecting bottom margin into masonry cell
    let gutterWidth = masonGrid.querySelector(".gutter-sizer").scrollWidth;
    let cells = masonGrid.getElementsByClassName("cell");
    for (var i = 0; i < cells.length; i++) {
      cells[i].style.marginBottom = gutterWidth + "px";
    }

    const msnry = new Masonry(masonGrid, {
      itemSelector: ".cell",
      columnWidth: ".grid-sizer",
      gutter: ".gutter-sizer",
    });
    msnry.layout();

    function onLayoutComplete() {
      // run lazyload after masonry has run
      const masonLoad = new LazyLoad({
        elements_selector: ".masonlazy",
      });
    }
    msnry.on("layoutComplete", onLayoutComplete);
  });

  //initialize flickity for slideshows

  let slideshowEl = document.querySelector(".slideshow");

  if (typeof slideshowEl != "undefined" && slideshowEl != null) {
    let slideshowSlides = slideshowEl.querySelectorAll(".cell");

    function nextSlide(duration) {
      // in case no duration is passed, default to 4 seconds
      if (!duration) {
        duration = 4;
      }

      // duration is in seconds, need to conver to milliseconds
      duration = duration * 1000;

      // transition to next slide 500 milisenconds before slide duration ends
      setTimeout(function () {
        // get next active slide and call nextSlide again, if last slide, go to first
        let activeSlide = slideshowEl.querySelector(".is-selected");

        let nextSlideEl = activeSlide.nextElementSibling;
        if (nextSlideEl == null) {
          nextSlideEl = slideshowEl.querySelector(".cell");
        }
        // get the index of the nextSlideEl
        let nextSlideIndex = flkty.getCellElements().indexOf(nextSlideEl);
        flkty.select(nextSlideIndex);

        let slideDuration = nextSlideEl.getAttribute("data-duration");
        let nextVideoEl = nextSlideEl.querySelector("video");
        if (nextVideoEl != "undefined" && nextVideoEl != null) {
          nextVideoEl.play();
        }
        nextSlide(slideDuration);
      }, duration - 500);
    }

    let flkty = new Flickity(slideshowEl, {
      // options
      fade: true,
      cellSelector: ".cell",
      pageDots: true,
      wrapAround: false,
      prevNextButtons: false,
      pauseAutoPlayOnHover: false,
      on: {
        ready: function () {
          // get active slide and get duration
          let activeSlide = slideshowEl.querySelector(".is-selected");
          let slideDuration = activeSlide.getAttribute("data-duration");
          let activeVideoEl = activeSlide.querySelector("video");
          if (activeVideoEl != "undefined" && activeVideoEl != null) {
            activeVideoEl.play();
          }

          // if only one slide, don't run nextSlide, just add loop to video element
          if (slideshowSlides.length == 1) {
            activeVideoEl.setAttribute("loop", "true");
          } else {
            nextSlide(slideDuration);
          }
        },
      },
    });
  }

  // check for media controls on page load and init

  let fullVideoControls = document.querySelector(".media .controls");
  if (typeof fullVideoControls != "undefined" && fullVideoControls != null) {
    videoControls(document.querySelector(".media"));
  }

  // CUSTOM VIDEO CONTROLS =========================
  function videoControls(player) {
    let video = player.querySelector("video");
    let controls = player.querySelector(".controls");
    let largeBtn = player.querySelector(".largeBtn");
    let playpauseBtn = player.querySelector(".playpause");
    let muteBtn = player.querySelector(".mute");
    let volumeSlider = player.querySelector("#volume-bar");
    let volumeBg = player.querySelector(".volume .bg");
    let seekSlider = player.querySelector("#seek-bar");
    let seekBg = player.querySelector(".scrubber .bg");
    let fullBtn = player.querySelector(".gofull");
    let closeBtn = player.querySelector(".close-icon");
    let timestampEl = player.querySelector(".timestamp");
    let durationEl = player.querySelector(".timestamp .duration");
    let progressEl = player.querySelector(".timestamp .progress");

    // event listeners
    //video.addEventListener("canplay", videoCanPlay);
    video.addEventListener("playing", videoPlaying);
    video.addEventListener("pause", videoPaused);
    video.addEventListener("timeupdate", videoTimeUpdate);
    video.addEventListener("ended", videoEnded);
    largeBtn.addEventListener("click", playPause);
    video.addEventListener("click", playPause);
    playpauseBtn.addEventListener("click", playPause);
    muteBtn.addEventListener("click", volumeToggle);
    seekSlider.addEventListener("input", videoSeek);
    //volumeSlider.addEventListener("input", volumeChange);
    fullBtn.addEventListener("click", goFullView);
    //closeBtn.addEventListener("click", closeFullView);

    // keyboard events
    body.addEventListener("keydown", (event) => {
      // toggle play / pause of video with spacebar

      // esc key closes lightbox
      if (event.keyCode === 27 && body.classList.contains("full")) {
        event.preventDefault();
        body.classList.remove("full");
      }
    });

    // show / hide controls based on mousemovement over video
    var mousetimeout;
    player.onmousemove = function () {
      clearTimeout(mousetimeout);
      controls.classList.remove("hide");
      mousetimeout = setTimeout(function () {
        // hide video controls if no mouse movement after 2 seconds
        controls.classList.add("hide");
      }, 2000);
    };

    player.onmouseleave = function () {
      controls.classList.add("hide");
    };

    // hide controls after 2 seconds is no user action is taken
    setTimeout(function () {
      controls.classList.add("hide");
    }, 2000);

    // functions
    function playPause() {
      if (!video.paused && !video.ended) {
        video.pause();
      } else {
        video.play();
      }
    }

    function toggleFullScreen() {
      if (
        !document.fullscreenElement &&
        !document.mozFullScreen &&
        !document.webkitIsFullScreen &&
        !document.msFullscreenElement
      ) {
        if (player.requestFullscreen) {
          player.requestFullscreen();
        } else if (player.mozRequestFullScreen) {
          player.mozRequestFullScreen();
        } else if (player.webkitRequestFullscreen) {
          player.webkitRequestFullscreen();
        } else if (player.msRequestFullscreen) {
          player.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    }

    function videoEnded() {
      player.classList.add("ended");
    }

    function videoCanPlay() {
      var vid_duration = video.duration;
      let vid_minutes = 0;
      let vid_seconds = 0;

      vid_minutes = parseInt(vid_duration / 60);
      if (vid_minutes < 10) {
        vid_minutes = `${vid_minutes}`;
      }
      vid_seconds = parseInt(vid_duration) - vid_minutes * 60;
      if (vid_seconds < 10) {
        vid_seconds = `0${vid_seconds}`;
      }

      var vid_dur_output = `${vid_minutes}:${vid_seconds}`;

      durationEl.innerHTML = vid_dur_output;
    }

    function videoPlaying() {
      body.classList.add("hide_mark");
      player.closest(".cell").classList.add("playing");
      player.classList.add("playing");
      player.classList.remove("ended");
      player.classList.remove("paused");
      timestampEl.classList.add("show");
    }

    function videoPaused() {
      player.classList.remove("playing");
      player.classList.add("paused");

      player.closest(".cell").classList.remove("playing");

      body.classList.remove("hide_mark");
    }

    function videoTimeUpdate() {
      let rawTime = video.currentTime;
      let minutes = 0;
      let seconds = 0;

      minutes = parseInt(rawTime / 60);
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      seconds = parseInt(rawTime) - minutes * 60;
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      let output = `${minutes}:${seconds}`;
      progressEl.innerHTML = output;

      // Calculate the slider value
      var value = (100 / video.duration) * video.currentTime;

      // transition the timestamp el by animation left value
      timestampEl.style.left = value + "%";

      // Update the slider value and bg value
      seekSlider.value = value;
      seekBg.style.width = value + "%";
    }

    function videoSeek() {
      // Calculate the new time
      var time = video.duration * (seekSlider.value / 100);

      // Update the video time
      video.currentTime = time;
    }

    function volumeToggle() {
      if (video.muted == false) {
        video.muted = true;
        player.classList.add("muted");
      } else {
        video.muted = false;
        player.classList.remove("muted");
      }
    }

    function volumeChange() {
      video.volume = volumeSlider.value;
      volumeBg.style.width = volumeSlider.value * 100 + "%";
    }

    function goFullView() {
      toggleFullScreen();
    }

    function closeFullView() {
      body.classList.remove("full");
    }
  }
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var readMoreTrigger = document.getElementById("readMoreBtn");

  if (typeof readMoreTrigger != "undefined" && readMoreTrigger != null) {
    readMoreTrigger.addEventListener("click", function (e) {
      e.preventDefault();

      let revealEl = document.querySelector(".reveal");

      if (revealEl.classList.contains("open")) {
        revealEl.style.height = 0;
        revealEl.classList.remove("open");
        readMoreTrigger.innerHTML = "Read more";
      } else {
        let revealInner = revealEl.querySelector(".inner");
        let revealH = revealInner.clientHeight;
        revealEl.style.height = revealH + "px";
        revealEl.classList.add("open");
        readMoreTrigger.innerHTML = "Read less";
      }
    });
  }

  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  function playAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-autovideo");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      videoEl.play();
    }
    el.classList.add("playing");
  }

  function pauseAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    videoEl.pause();
    el.classList.remove("playing");
  }

  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
  let resizeImageCells = document.getElementsByClassName("resize-image");
  for (let i = 0; i < resizeImageCells.length; i++) {
    resizeImage(resizeImageCells[i]);
  }

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */

  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  function playAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-autovideo");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      videoEl.play();
    }
    el.classList.add("playing");
  }

  function pauseAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    videoEl.pause();
    el.classList.remove("playing");
  }

  function loadImage(image) {
    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    if (!image.classList.contains("gif")) {
      if (newW <= 500) {
        imgpath = "/images/pics/500/" + img;
      } else if (newW > 500 && newW <= 750) {
        imgpath = "/images/pics/750/" + img;
      } else if (newW > 750 && newW <= 1000) {
        imgpath = "/images/pics/1000/" + img;
      } else if (newW > 1000 && newW <= 1536) {
        imgpath = "/images/pics/1536/" + img;
      } else if (newW > 1536 && newW <= 1920) {
        imgpath = "/images/pics/1920/" + img;
      } else {
        imgpath = "/images/pics/" + img;
      }
    } else {
      // load jpg as placeholder, when gif loaded swap
      imgpath = "/images/pics/500/" + img;
      fullpath = "/images/pics/" + img;

      var fullimg = new Image();
      fullimg.onload = function () {
        var fullImgSrc = fullimg.getAttribute("src");
        image.src = fullImgSrc;
        //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
      };
      fullimg.src = fullpath;
    }

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = imgpath;
        //image.classList.add("loaded");
      };
      newimage.src = imgpath;
    }
  }

  function wrapCols(el) {
    let elContainer = document.createElement("div");
    Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
      elContainer.appendChild(c);
    });
    elContainer.classList.add("cols");
    el.appendChild(elContainer);
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function openOverlay() {
    overlay.classList.add("on");
  }

  function closeOverlay() {
    overlay.classList.remove("on");
    overlayInner.innerHTML = "";
  }

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function resizeFrame(el) {
    let parent = el.closest(".vidhold"),
      pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  /* HANDLE WINDOW RESIZE */

  function reportWindowSize() {}

  window.addEventListener("resize", reportWindowSize);

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */

  // password form - svg icon needs to submit form on click
  let pwForm = document.getElementById("password_form");
  if (typeof pwForm != "undefined" && pwForm != null) {
    let pwSubmit = pwForm.querySelector(".arrow");
    pwSubmit.addEventListener("click", function (e) {
      e.preventDefault();
      pwForm.submit();
    });
  }

  // mailchimp newsletter signup

  let newsletterForm = document.getElementById("newsletter_form");
  if (typeof newsletterForm != "undefined" && newsletterForm != null) {
    // on arrow click submit the form
    let newsletterArrow = newsletterForm.querySelector(".arrow");
    newsletterArrow.addEventListener("click", function (e) {
      e.preventDefault();
      let email = newsletterForm.querySelector("#email").value;
      mc_subscribe(email);
    });

    // listen for submit
    newsletterForm.addEventListener("submit", function (e) {
      e.preventDefault();
      let email = newsletterForm.querySelector("#email").value;
      mc_subscribe(email);
    });
  }

  function mc_subscribe(email) {
    if (!email) {
      return;
    }

    // validate email for proper address with @ symbol and .
    let emailValid = email.includes("@") && email.includes(".");
    if (!emailValid) {
      return;
    }

    let statusEl = newsletterForm.querySelector("p.status");

    getAjax("/mc_api.php?email=" + email, function (data) {
      var response = JSON.parse(data);
      console.log(response);
      var status = response.status;
      if (status === "subscribed") {
        statusEl.innerHTML = "Welcome to the list!";
        newsletterForm.querySelector("#email").value = "";
      } else {
        statusEl.innerHTML = response.title;
      }

      /*

      if (status === "subscribed") {
        theSelForm.find("input[type='email']").hide();
        theFormWrap.find(".intro .error").html("<p>Thank You!</p>");
        theSelForm.addClass("submitted");
      } else {
        // error, output error details
        let errMsg = response.detail;
        if (response.title === "Member Exists") {
          errMsg = email + " has already been submitted";
          theSelForm.find("#email").val("");
        } else if (response.title === "Invalid Resource") {
          errMsg = "Please enter a valid email";
        }
        theFormWrap.find(".intro .error").html("<p>" + errMsg + "</p>");
      }

      */
    });
  }

  // down arrow
  let downArrowEl = document.querySelector(".downArrow");
  if (typeof downArrowEl != "undefined" && downArrowEl != null) {
    downArrowEl.addEventListener("click", function (e) {
      zenscroll.toY(innerHeight);
    });
  }

  // SCROLL ==================================
  window.addEventListener(
    "scroll",
    function () {
      st = window.pageYOffset || document.documentElement.scrollTop;

      if (typeof downArrowEl != "undefined" && downArrowEl != null) {
        if (st > 100) {
          this.document.querySelector(".downArrow").classList.add("hide");
        } else {
          this.document.querySelector(".downArrow").classList.remove("hide");
        }
      }

      lastScrollTop = st;
    },
    false
  );

  // overlay links
  let overlayLinks = document.querySelectorAll(".openOverlay");
  overlayLinks.forEach((overlayLink) => {
    overlayLink.addEventListener("click", function (e) {
      e.preventDefault();
      let id = overlayLink.getAttribute("data-id");
      getAjax("/getItem.php?id=" + id, function (data) {
        overlayInner.innerHTML = data;
        openOverlay();
      });
    });
  });

  //hamburger menu toggle
  menuBtn.addEventListener(
    "click",
    function (event) {
      event.preventDefault();
      if (body.classList.contains("menuOn")) {
        body.classList.remove("menuOn");
        /*
        setTimeout(function () {
          gsap.to(navItems, { opacity: 0, y: "2rem", stagger: 0 });
        }, 400);
        */
      } else {
        body.classList.add("menuOn");
        /*
        gsap.to(navItems, { opacity: 1, y: 0, stagger: 0.15 });
        */
      }
    },
    true
  );

  // close overlay
  overlayCloser.addEventListener(
    "click",
    function (event) {
      event.preventDefault();
      closeOverlay();
    },
    true
  );
});
